export default __webpack_public_path__ + "static/gajarbarfi-49732538aa1c722ef88cf03523204bf3.png";